import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import OrganisationUnitForm from "../../../Components/Forms/Pages/HR/OrganisationUnit/OrganisationUnitForm";
import { addOrganisationUnit, getOrganisationUnits } from "../../../Services/HR/OrganisationUnitService";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const AddOrganisationUnit = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.organisationUnit.addOrganisationUnit.pageTitle);
    });

    useEffect(() => {
        fetch();
    },[])

    const onSubmit = (data) => {
        setShowLoader(true);

        addOrganisationUnit(data).then(response => {
            setShowLoader(false);

            if(!response || !response.ok){
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    const fetch = (term = '') =>{
        getOrganisationUnits({term}).then(response => {
            if (!response || !response.ok){
                return;
            }
            setParents(response.data.result)
        })
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <OrganisationUnitForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents} onChangeUserFilter={fetch}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>

}

export default AddOrganisationUnit;